const isLoadingReducer = state => ({
  ...state,
  error: null,
  isLoading: true,
  successMessage: null,
});

export default isLoadingReducer;
